"use strict";

document.addEventListener("DOMContentLoaded", function () {
  //Document Ready

  // image alt
  const images = document.querySelectorAll('img');
  images.forEach((image) => {
    let src = image.getAttribute('src');

    //Split the file path by / character
    let filepathArr = src.split('/');

    //Get the name of the file be selecting the last item in the arrow and remvove the extension via replace regex
    let filename = filepathArr[filepathArr.length - 1].replace(/\.[^/.]+$/, '');

    //If an image doesn't have an alt attribute we need to set one.  If it is a link then it needs to have something defined.
    if (image.parentElement.tagName == "A") {
      if (!(image.getAttribute('alt'))) {
        image.setAttribute('alt', 'image ' + filename);
      }
    } else {
      if (!(image.getAttribute('alt'))) {
        image.setAttribute('alt', '');
      }
    }
  });

  // responsive tables
  const tables = document.querySelectorAll('main table');
  tables.forEach((table) => {
    if (table.closest('.search-results') === null && !(table.classList.contains('responsive-table'))) {
      table.classList.add('responsive-table');
    }
  });

  const tableHeaders = document.querySelectorAll('main table th');
  tableHeaders.forEach((header) => {
    header.style.width = 'auto';
  });

  const tableCells = document.querySelectorAll('main table td');
  tableCells.forEach((cell) => {
    cell.style.width = 'auto';
  });


  // breadcrumbs
  if (document.querySelector('ul.breadcrumb') !== null) {
    const homeCrumb = document.createElement('li');
    const homeLink = document.createElement('a');
    homeLink.href = "/";
    homeLink.text = "Home";
    homeCrumb.append(homeLink);
    document.querySelector('ul.breadcrumb').before(homeCrumb);
  }

  var subpageBannerUrl = document.querySelector('.banner-wrapper').style["background-image"];

  if (subpageBannerUrl == 'url("")' || subpageBannerUrl == 'none' || subpageBannerUrl == 'url("{{banner-background}}")') {
    document.querySelector('.banner-wrapper').style['background-image'] = "";
  }
});


